import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogContentText } from '@mui/material';
import palette from 'src/theme/palette';
import Iconify from 'src/components/Iconify';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';

const DeleteModal = ({ open, onClose, onConfirm, loading, title, description }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogContent sx={{ display: 'flex', width: 500 }}>
      <Box
        sx={{
          backgroundColor: '#FEE2E2',
          borderRadius: 100,
          height: 40,
          width: 40,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Iconify icon={'typcn:warning-outline'} style={{ fontSize: 25, color: 'red' }} />
      </Box>

      <Box sx={{ ml: 2, flex: 1 }}>
        <DialogContentText
          sx={{ color: palette.primary.titledark, fontFamily: 'poppinsMedium', fontSize: 18 }}
        >
          {title}
        </DialogContentText>
        <DialogContentText
          sx={{
            color: palette.primary.tittableHeadTitleledark,
            fontFamily: 'poppinsRegular',
            fontSize: 12,
            flex: 1
          }}
        >
          {description}
        </DialogContentText>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2 }}>
          <LoadingButtonWrapper
            onClick={onConfirm}
            loading={loading}
            variant="contained"
            sx={{
              backgroundColor: '#DC2626',
              width: loading ? 120 : 90,
              height: 30,
              fontSize: 12,
              borderRadius: 0.7,
              fontFamily: 'poppinsLight',
              letterSpacing: 0.3,
              transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease',
              '&:hover': {
                backgroundColor: '#b91c1c'
              }
            }}
            title="Delete"
          />

          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              ml: 1.5,
              color: palette.primary.pageButtonTitle,
              borderColor: palette.primary.pageButtonBorder,
              fontSize: 12,
              fontFamily: 'poppinsRegular',
              borderRadius: 0.7,
              '&:hover': {
                backgroundColor: palette.primary.inputborder,
                borderColor: palette.primary.pageButtonBorder
              }
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </DialogContent>
  </Dialog>
);

export default DeleteModal;
